/**
 * @fileoverview Select Component
 *
 * Native select element using Tailwind CSS for styling.
 * For advanced dropdowns, consider Radix UI Select in the future.
 * Follows CLAUDE.md guidelines: Tailwind utilities, no separate CSS files.
 */

import * as React from "react";
import { cn } from "@/lib/utils";

export interface SelectProps
	extends React.SelectHTMLAttributes<HTMLSelectElement> {
	error?: boolean;
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
	({ className, error, children, ...props }, ref) => {
		return (
			<select
				className={cn(
					"flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm",
					"ring-offset-background",
					"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
					"disabled:cursor-not-allowed disabled:opacity-50",
					error && "border-destructive focus-visible:ring-destructive",
					className,
				)}
				ref={ref}
				{...props}
			>
				{children}
			</select>
		);
	},
);
Select.displayName = "Select";

export { Select };
